<template>
  <div id="app">
    <div :class="loading ? 'app-loading' : 'app-initialized'">Loading...</div>
    <router-view/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'App',
  computed: {
    loading() {
      return store.state.user.id && !store.state.app.initialized
    }
  },
  created () {
    window.addEventListener('keydown', this.refreshOnF5)
  },
  destroyed () {
    window.removeEventListener('keydown', this.refreshOnF5)
  },
  mounted () {
    const spacing = '2px';
    const colorBlue = '#27cd00';
    const styles = `padding: ${spacing}; color: ${colorBlue}; background-color: #e5eaef; font-size: 1.3em;
          border-top: ${spacing} dashed ${colorBlue}; border-bottom: ${spacing} dashed ${colorBlue};`;
    console.log('%cWelcome back, Bro!', styles);
  },
  methods: {
    refreshOnF5 (e) {
      if (e.key === 'F5') {
        const { fullPath } = this.$route

        this.$nextTick(() => {
          console.clear()

          const spacing = '2px';
          const colorBlue = '#5e7b9b';
          const styles = `padding: ${spacing}; color: ${colorBlue}; background-color: #e5eaef; font-size: 1.2em;
          border-top: ${spacing} dashed ${colorBlue}; border-bottom: ${spacing} dashed ${colorBlue};`;
          console.log('%cREFRESH page', styles);

          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })

        e.preventDefault()
        e.stopPropagation()
        e.cancelBubble = true
      }
    }
  }
}
</script>

<style lang="scss">
  /*@import url('https://fonts.googleapis.com/css?family=Exo+2');*/
  @import "~@/styles/fonts.scss";

  #app {
    font-family: 'Exo 2', 'Avenir', Helvetica, Arial, sans-serif;
    /*font-family: 'Roboto Mono', monospace;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    user-select: none;
  }

  .ui.button {
    font-family: 'Exo 2', 'Avenir', Helvetica, Arial, sans-serif;
    font-weight: normal;
  }

  .app-initialized {
    display: none;
  }
  .app-loading {
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 2000;
    border: 1px solid #a2b3c5;
    border-bottom: none;
    border-left: none;
    padding: 3px 6px;
    background-color: #a2b3c5dd;
    color: #fff;
    font-size: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue